export const HeatmapConstants = {
    HEATMAP_INTENSITY: 0.4,
    POINT_VALUE: 100,
    POINT_RADIUS_METERS: 4,
};
